import styled, { keyframes } from 'styled-components';
import bgTelegramSectionImg from "../../img/bg-telegram.png";

const pulseShadowTelegram = keyframes`
  20% {
    box-shadow: 0px 0px 10px 0px rgb(0, 136, 187);
  }
  50% {
    box-shadow: rgb(0 188 227) 0px 0px 10px;
    transform: scale(1.01);
  }
  100% {
    box-shadow: 0px 0px 10px 0px rgb(0, 136, 187);
  }
`;

export const SectionTelegramWrapper = styled.section`
  position: relative;
  overflow: hidden;
  padding: 40px; /* Pode ser alterado conforme necessário */
  background-image: url(${bgTelegramSectionImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .row-primary {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    h1 {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 1.8rem;
      font-family: "Rubik";
      color: #007bff;
      img {
        width: 30px;
      }
    }

    p {
      font-size:1.1rem;
    }

    button {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      margin-top: 16px;
      padding: 28px 15px;
      font-size: 1.2rem;
      font-weight: 500;
      border: none;
      border-radius: 20px;
      background: linear-gradient(45deg, rgb(0, 136, 187), rgba(0, 136, 204, 0.48)) rgb(0 188 227);
      color: rgb(255, 255, 255);
      cursor: pointer;
      transition: background-color 0.3s ease 0s;
      outline: none;
      background-color: #0056b3;
      animation: ${pulseShadowTelegram} 2s infinite;
      0px 0px 10px 10px rgb(0 188 227 / 26%);
      width: 100%;
      max-width: 500px;
      svg {
        margin-left: 10px;
      }
    }

  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }
`;
